import React,{useState} from "react"
import Api from "./Api";
import { useGlobal } from "./Reducer";



export default (props)=>{

 
    const articles=props.articles;
    const last=props.article;
    const [gs,ga]=useGlobal();


    const [articleIndex,setArticleIndex]=useState( [articles[0].id,articles[1].id].indexOf(last.id));
    const article=articles[articleIndex];


    const toggle=(e)=>{
        e.preventDefault();
        setArticleIndex(articleIndex==0?1:0);
        Api.recordAnalytics(gs.appData.id,"ARTICLE_OPEN",article.title,article.id);

    }
     


    return (<div className="whitebg boxed  recent_news"><div className="row"><div className="col"> 
        
        <a href="#" 
            onClick={(e)=>{
                e.preventDefault();
                setArticleIndex(0);
            }}
            
            className="recent_news_thumb" ref_id="1686">
        <img src={articles[0].image} 
         style={{opacity:articleIndex==1?.2:1}} 
        className="recent_newsimg" alt={article.title}/>
        </a>
        </div><div className="col">
            <a href="#" 
            onClick={(e)=>{
                e.preventDefault();
                setArticleIndex(1);
            }}
            
            className="recent_news_thumb" ref_id="1686"><img 
        src={articles[1].image} 
        className="recent_newsimg recent_news_learnmore" style={{opacity:articleIndex==0?.2:1}} alt={articles[1].title} ref_id="1686"/></a></div></div><div className="recent_news_intro lvl1 graytext padded">{article.title}</div>
            {article.byline && <span className="news_summary" style={{fontSize:10,fontStyle:"italic"}}>
            {article.byline}
            </span>}
        
            <div dangerouslySetInnerHTML={{__html:article.intro}} className="news_summary">
                  
            </div>
            <div  dangerouslySetInnerHTML={{__html:article.body}} className="news_summary">
         
            
            </div>
            
            
            <div className="row padded"><div className="col-8 navbtns"><a href="#"
                onClick={(e)=>{
                    e.preventDefault();
                    props.onClose();
                }}
            
            className="close_news dpl_btn">Close</a></div>
            <div className="col-4 text-right navbtns"><a href="#" onClick={toggle} className="recent_news_learnmore dpl_btn_arrowleft"  >Previous</a><a href="#" className="recent_news_learnmore dpl_btn" onClick={toggle} >Next </a></div></div></div>);

}